import { inview } from "./inview.js";

export const projectModal = () => {
  const modal = document.getElementById("projectModal");
  if (!modal) return;

  const closeBtn = document.getElementById("closeModal");
  const overlay = modal.querySelector(".project-modal__overlay");

  // IntersectionObserverのインスタンスを保持
  let modalInviewObserver = null;

  // モーダルを開く
  function openModal(postId) {
    // AJAXで投稿データを取得
    fetch(window.wp_ajax_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: "action=get_project_details&post_id=" + postId,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          updateModalContent(data.data);
          // モーダルのスクロール位置をトップにリセット
          overlay.scrollTop = 0;
          // z-indexを戻す
          modal.style.zIndex = "";
          modal.classList.add("is-open");
          document.body.classList.add("is-project-modal-open");
          document.body.style.overflow = "hidden";

          // モーダル内のinview要素のクラスをリセット
          resetModalInview();

          // 画像のopacityを1にする（少し遅延させてトランジション効果を確実にする）
          setTimeout(() => {
            const modalImageContainer = document.querySelector(".project-modal__image");
            if (modalImageContainer) {
              modalImageContainer.style.opacity = "1";
            }
          }, 50);

          // モーダル表示後にinviewを開始
          setTimeout(() => {
            initModalInview();
          }, 300);
        }
      });
  }

  // モーダル内容を更新
  function updateModalContent(data) {
    document.getElementById("modalImage").src = data.thumbnail || "";
    document.getElementById("modalImage").alt = data.title || "";
    document.getElementById("modalTitle").textContent = data.title || "";
    document.getElementById("modalSubTitle").textContent = data.sub_title || "";
    document.getElementById("modalClientName").textContent = data.client || "";

    document.getElementById("modalOverview").innerHTML = data.overview || "";
    document.getElementById("modalContent").innerHTML = data.content || "";

    // overviewの直下要素にinviewクラスを追加
    const overviewElement = document.querySelector(".project-modal__overview-content");
    if (overviewElement && overviewElement.children.length > 0) {
      Array.from(overviewElement.children).forEach((child) => {
        child.classList.add("inview");
      });
    }

    // Scope表示
    const scopeCol = document.getElementById("modalScopeCol");
    if (data.scope && data.scope.trim() !== "") {
      document.getElementById("modalScope").innerHTML = data.scope;
      scopeCol.style.display = "block";
    } else {
      scopeCol.style.display = "none";
    }

    // Member表示
    const memberCol = document.getElementById("modalMemberCol");
    if (data.member && data.member.trim() !== "") {
      document.getElementById("modalMember").innerHTML = data.member;
      memberCol.style.display = "block";
    } else {
      memberCol.style.display = "none";
    }

    // カテゴリー表示
    const categoryContainer = document.getElementById("modalCategory");
    categoryContainer.innerHTML = "";
    if (data.categories && data.categories.length > 0) {
      data.categories.forEach((cat) => {
        const li = document.createElement("li");
        li.textContent = cat;
        categoryContainer.appendChild(li);
      });
    }

    // ギャラリー表示
    document.getElementById("modalGallery").innerHTML = data.gallery || "";
  }

  // モーダルを閉じる
  function closeModal() {
    modal.classList.remove("is-open");
    document.body.classList.remove("is-project-modal-open");
    document.body.style.overflow = "";

    // inviewをリセット
    resetModalInview();

    // Observerがあれば切断
    if (modalInviewObserver) {
      modalInviewObserver.disconnect();
      modalInviewObserver = null;
    }

    // 画像のopacityを0に戻す
    const modalImageContainer = document.querySelector(".project-modal__image");
    if (modalImageContainer) {
      modalImageContainer.style.opacity = "0";
    }

    // トランジション終了後にz-indexを下げる
    setTimeout(() => {
      modal.style.zIndex = "-1";
    }, 300);
  }

  // モーダル内のinview要素をリセット
  function resetModalInview() {
    const inviewElements = modal.querySelectorAll(".inview");
    inviewElements.forEach((el) => {
      el.classList.remove("inview-is-visible");
    });
  }

  // モーダル内のinviewを初期化
  function initModalInview() {
    const inviewElements = modal.querySelectorAll(".inview");

    const cb = function (entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add("inview-is-visible");
            observer.unobserve(entry.target);
          }, 100);
        }
      });
    };

    modalInviewObserver = new IntersectionObserver(cb, {
      root: overlay, // モーダルのスクロール領域をルートに設定
      threshold: 0.1,
    });

    inviewElements.forEach((el) => {
      modalInviewObserver.observe(el);
    });
  }

  // イベントリスナー
  closeBtn.addEventListener("click", closeModal);
  overlay.addEventListener("click", function (e) {
    if (e.target === overlay) {
      closeModal();
    }
  });

  // ESCキーでモーダルを閉じる
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.classList.contains("is-open")) {
      closeModal();
    }
  });

  // プロジェクトアイテムをクリックしたときの処理
  document.addEventListener("click", function (e) {
    const projectItem = e.target.closest(".project__item-card");
    if (projectItem) {
      e.preventDefault();
      const postId = projectItem.dataset.postId;
      if (postId) {
        openModal(postId);
      }
    }
  });
};
